<style lang="scss">
.group-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .label {
    font-size: 13px;
  }
}
</style>
<template>
  <div class="group-btn">
    <div class="label">
      {{ label }}
    </div>
    <el-button-group>
      <el-button
        v-for="(item, index) in btns"
        :key="`el-button__${index}`"
        size="mini"
        :type="value == item.value ? 'primary' : ''"
        @click="handleClickBtn(item)"
      >
        {{ item.name }}
      </el-button>
    </el-button-group>
  </div>
</template>

<script>
export default {
  name: 'GroupBtn',
  props: {
    label: String,
    btns: Array,
    value: [String, Number, Boolean]
  },
  data () {
    return {}
  },
  created () {},
  methods: {
    handleClickBtn (item) {
      this.$emit('input', item.value)
    }
  }
}
</script>
